module.exports = __webpack_public_path__ + "static/media/linkedin.bc81dcef.png";